import React from 'react';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { BookOpen, BarChart3, Award, Users } from 'lucide-react';

const DashboardStatsSkeleton: React.FC = () => {
  const statCards = [
    { icon: BookOpen, title: 'Courses' },
    { icon: BarChart3, title: 'Progress' },
    { icon: Award, title: 'Certificates' },
    { icon: Users, title: 'Streak' }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {statCards.map(({ icon: Icon, title }, index) => (
        <Card key={index} className="transition-all duration-200">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <Skeleton className="h-4 w-16" />
            <Icon className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <Skeleton className="h-8 w-12 mb-1" />
            <Skeleton className="h-3 w-20" />
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default DashboardStatsSkeleton;